import { ButtonComp, ModalCompAdvanceUpdate } from "../../../components";
import CalendarComp from "../../../components/Common/CalendarComp";
import FallbackImage from "../../../components/Common/ImageWrapper";
import ListMessage from "./modules/listMessage";
import {
  useGetBirthdayMessagesQuery,
  useGetBirthdaysQuery,
} from "../../../store/admin/automatedBirthdaySlice";
import { PageTitle } from "../modules/PageHeaders";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MessageForm from "./modules/MessageForm";
import useAutomatedBirthdayAction from "./useAutomatedBirthdayAction";
import BirthdaySettings from "./BirthdaySettings";
import BirthdayLogs from "./BirthdayLogs";
import StaffReceivedWishes from "./modules/StaffReceivedWishes";

export default function AutomatedBirthdayHome() {
  const [activeTab, setActiveTab] = useState("Dashboard");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("tab") === "received") {
      setActiveTab("My Received Wishes");
    }
  }, [location.search]);
  const { addBirthMessage, editBirthMessage, makeDefault, sendManualWish } = useAutomatedBirthdayAction();

  const { data: birthdayMessages = [] } = useGetBirthdayMessagesQuery(1);
  const { data: birthdaysData = {} } = useGetBirthdaysQuery(1);

  const automated_birthdays = birthdaysData.automated_birthdays?.automated_birthdays || birthdaysData.automated_birthdays?.data || birthdaysData.automated_birthdays || [];
  const automated_birthday_messages = birthdayMessages.automated_birthday_messages || [];
  
  const defaultMessage = automated_birthday_messages.find(msg => msg.is_active === 1) || automated_birthday_messages[0];
  const customTemplates = automated_birthday_messages.filter(msg => msg.id !== defaultMessage?.id);
  
  const [modalName, setModalName] = useState();
  const [initialMessage, setInitialMsg] = useState("");
  const [messageId, setMsgId] = useState(null);
  const [selectedCelebrant, setSelectedCelebrant] = useState(null);

  const tabs = ["Dashboard", "Settings", "Message Logs", "My Received Wishes"];

  const initiateEdit = (item) => {
    setInitialMsg(item?.message);
    setMsgId(item?.id);
    setModalName("Edit Message");
  };

  const handleSendWish = (item) => {
    setSelectedCelebrant(item);
    setModalName("Send Manual Wish");
  };

  const onManualWishSubmit = (message) => {
    if (!message.length > 3) return;
    sendManualWish({
      recipient_id: selectedCelebrant.id,
      recipient_type: selectedCelebrant.user_type,
      message: message
    });
    setModalName();
  };

  const newMsg = (message) => {
    if (!message.length > 3) return;
    addBirthMessage({ message: message });
    setModalName();
  };

  const patchMsg = (message) => {
    if (!message.length > 3) return;
    editBirthMessage({ message: message, id: messageId });
    setModalName();
  };

  const useModal = [
    {
      name: "Create Message",
      component: (
        <MessageForm
          onProceed={newMsg}
          title={"Create Message"}
          onBack={() => setModalName()}
        />
      ),
    },
    {
      name: "Edit Message",
      component: (
        <MessageForm
          onProceed={patchMsg}
          title={"Edit Message"}
          onBack={() => setModalName()}
          initialMessage={initialMessage}
        />
      ),
    },
    {
      name: "Send Manual Wish",
      component: (
        <MessageForm
          onProceed={onManualWishSubmit}
          title={`Send Birthday Wish to ${selectedCelebrant?.first_name}`}
          onBack={() => setModalName()}
          initialMessage={`Happy Birthday ${selectedCelebrant?.first_name}! 🎂`}
        />
      ),
    },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "Dashboard":
        return (
          <div className="row gx-0 px-0 px-lg-0 justify-content-between">
            <div className=" col-lg-6 bg-white px-lg-4 py-5 d-flex justify-content-start flex-column align-items-center rounded-4 shadow3">
              <h5 className="text-center mb-3 fw-bold">Birthday calendar</h5>
              <div className="col-lg-10 mb-3">
                <CalendarComp />
              </div>
              <div className="w-100">
                <h5 className="text-center mb-3 fw-bold" data-tour="staff-bday-today">
                  Members Celebrating Today
                </h5>
                <div className="d-flex justify-content-center">
                  <div className="col-12 col-lg-10 text-center py-4 rounded-4 shadow-sm border bg-light-soft animate__animated animate__fadeIn">
                    {automated_birthdays.length === 0 ? (
                      <div className="py-4">
                        <div 
                          className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3 bg-white shadow-sm"
                          style={{ width: '80px', height: '80px', fontSize: '40px' }}
                        >
                          🍰
                        </div>
                        <h6 className="fw-bold text-black1 mb-2">No Birthdays Today</h6>
                        <p className="text-blacklight small mb-0 px-4">
                          There are no members or staff celebrating their birthday today.
                        </p>
                      </div>
                    ) : (
                      <div 
                        className="px-4 d-flex flex-column gap-3"
                        style={{ maxHeight: '400px', overflowY: 'auto', scrollbarWidth: 'thin' }}
                      >
                        {automated_birthdays?.map((item, i) => (
                          <div
                            key={i}
                            className="d-flex align-items-center justify-content-between fw-2 flex-wrap p-2 rounded-3 hover:bg-light pointer transition-all"
                            onClick={() => {
                              const path = item?.user_type === 'member' 
                                ? `/super_admin/member_management/members/${item?.id}`
                                : `/super_admin/staff_registration/view_staff/${item?.id}`;
                              navigate(path);
                            }}
                          >
                            <div className="d-flex align-items-center mb-lg-0">
                              <FallbackImage
                                src={item?.photo || "/Staff/avatar.svg"}
                                className="rounded-circle me-3"
                                width="40px"
                                height="40px"
                              />
                              <p className="h60 mb-0 fw-bold">
                                {item?.first_name} {item?.last_name}
                              </p>
                            </div>
                            <div className="d-flex align-items-center gap-3">
                              <div
                                className="rounded-pill h60 px-3 py-1"
                                style={{
                                  background: item?.user_type === 'member' ? "var(--color-secondary-soft)" : "var(--color-primary-soft)",
                                  color: item?.user_type === 'member' ? "var(--color-secondary)" : "var(--color-primary)",
                                  fontSize: "12px",
                                }}
                              >
                                {item?.user_type}
                              </div>
                              <span data-tour="staff-bday-wish">
                              <ButtonComp
                                btnText="Wish"
                                btnClassName="bg-primary1 text-white rounded-pill px-3 py-1 border-0"
                                ButtonInlineStyle={{ fontSize: "11px", minWidth: "60px" }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSendWish(item);
                                }}
                              />
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-5">
              <div className="bg-white p-4 rounded-4 shadow3 mb-4">
                <h4 className="fw-bold text-black1 mb-3">
                  Custom Birthday Messages
                </h4>
                <p className="small text-blacklight mb-4">
                  Create different templates for automated birthday wishes.
                </p>
                <div data-tour="staff-bday-wish">
                <ButtonComp
                  btnText={"Create message"}
                  btnClassName={"bg-primary1 text-white rounded-10 px-4 py-3 border-0"}
                  onClick={() => setModalName("Create Message")}
                />
                </div>
              <div>
                <h5 className=" mb-3 fw-bold text-black1 d-flex align-items-center gap-2">
                  <span className="dot bg-primary1" style={{width: '8px', height: '8px', borderRadius: '50%'}}></span>
                  Default message
                </h5>
                <ListMessage
                  message={defaultMessage?.message}
                  onClickEdit={() => initiateEdit(defaultMessage)}
                  showDefaultBtn={false}
                />
                <div className="my-4">
                  <hr style={{ color: "#E0E0E0", borderWidth: "2px" }} />
                </div>
                <h5 className=" mb-3 fw-bold text-black1 d-flex align-items-center gap-2">
                  <span className="dot bg-secondary2" style={{width: '8px', height: '8px', borderRadius: '50%'}}></span>
                  Custom templates
                </h5>
                <div className="listMessage space-y-3">
                  {customTemplates.length === 0 ? (
                    <div className="d-flex justify-content-center">
                      <div className="bg-white col-12 text-center py-5 rounded-4 border dashed">
                        <FallbackImage
                          src="/Icon/nomessage.svg"
                          className="mb-3 opacity-50"
                        />
                        <p className="text-blacklight">No additional templates found</p>
                      </div>
                    </div>
                  ) : (
                    <>
                      {customTemplates.map((item, i) => (
                        <ListMessage
                          key={i}
                          message={item?.message}
                          onClickEdit={() => initiateEdit(item)}
                          onClickMakeDefault={() => makeDefault(item?.id)}
                        />
                      ))}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          </div>
        );
      case "Settings":
        return <BirthdaySettings />;
      case "Message Logs":
        return <BirthdayLogs />;
      case "My Received Wishes":
        return <StaffReceivedWishes />;
      default:
        return null;
    }
  };

  return (
    <>
      <section className="px-3 px-lg-5 min-vh-100 pb-5 mb-5">
        <div className="mt-1">
          <PageTitle title={"Automated Birthday Engagement"} />
        </div>

        {/* Tab Navigation */}
        <div className="d-flex gap-4 mb-4 border-bottom mt-4">
          {tabs.map((tab) => (
            <div
              key={tab}
              className={`pb-2 pointer fw-bold transition-all ${
                activeTab === tab
                  ? "text-primary1 border-bottom border-primary1 border-3"
                  : "text-blacklight hover:text-black1"
              }`}
              onClick={() => setActiveTab(tab)}
              style={{ fontSize: "16px" }}
            >
              {tab}
            </div>
          ))}
        </div>

        {renderContent()}
      </section>

      <ModalCompAdvanceUpdate
        arrayComp={useModal}
        centered={true}
        pageName={modalName}
        handleClose={() => setModalName()}
        close={true}
      />
    </>
  );
}
